import { FunctionComponent } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { SidebarItem } from '../../SidebarItem/SidebarItem';
import { SidebarSection } from '../../SidebarSection/SidebarSection';

export const SidebarBetaSection: FunctionComponent = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  function didSelectRoute(route: string): void {
    navigate(route);
  }

  return (
    <SidebarSection title="Beta">
      <SidebarItem
        isSelected={pathname === '/feedback'}
        icon="/images/icons/bug_red.svg"
        selectedIcon="/images/icons/bug_white.svg"
        onClick={(): void => didSelectRoute('/feedback')}
      >
        Feedback
      </SidebarItem>
    </SidebarSection>
  );
};
